// @ts-strict-ignore
import { ArticleUtils } from '@article/util/article-utils';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { DimensionsVO } from '../../../model/vo/dimensions.vo';
import { ProjectVO } from '../../../model/vo/project.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { Box3, Vector3 } from 'three';
import { Injectable } from '@angular/core';
import { ArticleUsageService } from '@article/service/article-usage.service';
import { ProjectUtils } from '../util/project-utils';

@Injectable({ providedIn: 'root' })
export class ProjectDimensionsService {
  constructor(
    private containerService: ContainerService,
    private articleUsageService: ArticleUsageService
  ) {}

  public calculateDimensions(project: ProjectVO): DimensionsVO {
    let articleContainers: ArticleContainer[] = this.getArticleContainersWithoutDrillingHolesAndWirebridge(ProjectUtils.getFirstArticleUsages(project));
    articleContainers = articleContainers.filter((articleContainer) => !ArticleUtils.isFreeMounting(articleContainer.article));
    const boundingBoxAllArticles = this.getContainerBounds(articleContainers);
    const size = boundingBoxAllArticles.getSize(new Vector3());
    const roundedSizeInMM = this.getRoundedSizeInMM(size);

    return roundedSizeInMM;
  }

  public getProjectWidth(project: ProjectVO): number {
    return this.calculateDimensions(project).width;
  }

  public getProjectBoundsBox(project: ProjectVO): Box3 {
    const articleContainers: ArticleContainer[] = this.getArticleContainersWithoutDrillingHolesAndWirebridge(ProjectUtils.getFirstArticleUsages(project));

    return this.getContainerBounds(articleContainers);
  }

  public getContainerBounds(containers: ArticleContainer[]): Box3 {
    const points: Vector3[] = [];
    for (const object of containers) {
      const boundingBox: Box3 = object.bounds.clone();
      boundingBox.applyMatrix4(object.matrix);
      points.push(boundingBox.min, boundingBox.max);
    }
    return new Box3().setFromPoints(points);
  }

  private getRoundedSizeInMM(projectSize: Vector3) {
    const sizeInMM = projectSize.divideScalar(10);
    let rounded = new Vector3();
    rounded.x = Math.round(sizeInMM.x * 100) / 100;
    rounded.y = Math.round(sizeInMM.y * 100) / 100;
    rounded.z = Math.round(sizeInMM.z * 100) / 100;
    const projectDimensions: DimensionsVO = {
      height: rounded.y,
      width: rounded.z,
      length: rounded.x,
    };
    return projectDimensions;
  }

  private getArticleContainersWithoutDrillingHolesAndWirebridge(articleUsages: ArticleUsageVO[]): ArticleContainer[] {
    const articleUsageIds: string[] = [];

    for (const articleUsage of articleUsages) {
      if (
        !(
          this.articleUsageService.isWireBridgeArticleUsage(articleUsage) ||
          this.articleUsageService.isDrillingHoleArticleUsage(articleUsage,)
        )
      ) {
        articleUsageIds.push(articleUsage.id);
      }
    }
    const articleContainers: ArticleContainer[] = this.containerService.findArticleContainersInGlobalByGuids(articleUsageIds);
    return articleContainers;
  }
}
